import React from 'react';
import { Check } from 'lucide-react';
export function ProductSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-157">
      <div className="max-w-4xl mx-auto" data-id="element-158">
        <div className="text-center mb-12" data-id="element-159">
          <p className="text-xl font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-160">
            Te presentamos el
          </p>
          <h2 className="text-4xl md:text-5xl font-black text-blue-700 uppercase" data-id="element-161">
            KIT DE APRENDIZAJE EN CASA
          </h2>
        </div>

        <div className="bg-blue-50 border-4 border-blue-100 rounded-3xl p-8 md:p-12 shadow-lg" data-id="element-162">
          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-163">
            Un material práctico basado en herramientas psicopedagógicas que te
            ayudará a:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-164">
            {['comprender cómo aprende tu hijo', 'acompañarlo sin generar frustración', 'estimular su interés por aprender', 'mejorar la concentración y la comprensión', 'transformar el aprendizaje en una experiencia positiva'].map((item, index) => <div key={index} className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-blue-50" data-id="element-165">
                <div className="bg-green-100 rounded-full p-1 mr-4 flex-shrink-0 mt-1" data-id="element-166">
                  <Check className="h-6 w-6 text-green-600 stroke-[3]" data-id="element-167" />
                </div>
                <span className="text-lg font-semibold text-gray-800" data-id="element-168">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="text-center mt-10" data-id="element-169">
            <p className="inline-block bg-yellow-200 text-yellow-900 px-6 py-3 rounded-full text-xl font-bold" data-id="element-170">
              Todo explicado de forma simple y pensado especialmente para
              padres.
            </p>
          </div>
        </div>
      </div>
    </section>;
}